exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".upload-container[data-v-0c15f25e]{display:grid;gap:15px 15px;grid-template-columns:110px minmax(180px, 600px);align-self:center}.file-name[data-v-0c15f25e]{font-weight:bold}@media only screen and (max-width: 800px){.upload-container[data-v-0c15f25e]{grid-template-columns:minmax(180px, 1fr)}}\n", ""]);

